"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents a memory
 */
class Memory {
  constructor(fields) {
    if (!fields) {
      return;
    }

    (0, _assign2.default)(this, fields);
  }
}
exports.default = Memory;